<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="Deposit_icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path id="Path_8103" data-name="Path 8103" d="M0,0H24V24H0Z" fill="none" />
    <path
      id="Path_8104"
      data-name="Path 8104"
      d="M12,17V3m8,18H4m13-9-5,5L7,12"
      fill="none"
      :stroke="clr ? clr : '#002'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
